import { useState } from "react"
import { SingleSelectField } from "@inmagik/magik-ui"
import { optionsBlockTypes } from "../options"

export function BlockTypeSelector({ onSelect }: { onSelect: (type: string) => void }) {
  const [currentType, setCurrentType] = useState<string>("")

  return (
    <SingleSelectField
      value={optionsBlockTypes.find((o) => o.value === currentType) ?? undefined}
      label="Tipo di Blocco"
      layout="horizontal"
      options={optionsBlockTypes}
      onChange={(opt) => {
        if (!opt) return
        setCurrentType(opt.value)
        onSelect(opt.value)
      }}
    />
  )
}
